import { Tooltip2 } from '@blueprintjs/popover2';
import classNames from 'classnames';
import React from 'react';
import { MenuItemType } from '../../constants/types';
import { ProIntent, ProSize } from '../../utils/enums';
import { ProIcon } from '../Icons/Icon';

type Props = {
    item: MenuItemType;
    onClick: () => void;
    isActive?: boolean;
    size?: ProSize;
    title?: string;
};

export const ProMenuIcon = ({ item, isActive, size = ProSize.Large, title, onClick }: Props) => {
    const getCurIcon = () => {
        if (isActive && item.activeIcon) {
            return item.activeIcon;
        } else {
            return item.icon;
        }
    };
    const getHighlightClass = () => {
        if (isActive && item.activeIcon) {
            return 'ProMenuIcon--active';
        } else if (isActive) {
            return 'ProMenuIcon--active  ProMenuIcon--active-hightlight';
        } else {
            return '';
        }
    };

    return (
        <div
            onClick={onClick}
            className={classNames(
                'ProMenuItem',
                item.disabled && 'ProMenuIcon--disabled',
                isActive && 'ProMenuItem--active'
            )}
        >
            <Tooltip2 content={item.name} className="ProButton-Tooltip" placement="right" hoverOpenDelay={800}>
                <div className={classNames('ProMenuIcon', getHighlightClass())}>
                    <ProIcon icon={getCurIcon()} size={size} intent={isActive ? ProIntent.Primary : ProIntent.Light} />
                </div>
            </Tooltip2>
            {title && <h3>{title}</h3>}
        </div>
    );
};
